"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertV1 = void 0;

var Check = require("./Check");
/**
 * In progress
 */
// export function insert(
//     this: EBObject,
//     input: string | Element | EBObject | Function,
//     target: Element,
//     at?: number | string,
//     times?: number
// ) {
//     const posFromString = (at: string, childList: HTMLCollection) => {
//         const posMap: NumberObject = {
//             start: 0,
//             middle: Math.floor(childList.length / 2),
//             end: childList.length
//         }
//         return at in posMap ? posMap[at] : posMap.end
//     }
//     const safePos = (n: number, length: number) => {
//         return n < 0
//             ? Math.max(length + (n + 1), 0)
//             : Math.min(length, n)
//     }
//     const safeTimes = times ? Math.abs(Math.floor(times)) : 1
//     const computedInput = Parse.getComputedValue.call(this, input)
//     const fragment = Parse.getFragmentFrom(computedInput, safeTimes)
//     const childList = target.children
//     const n = Check.isString(at) ? posFromString(at, childList) : Math.floor(at as number)
//     const p = safePos(n, childList.length)
//     // console.log(
//     //     `input: ${input}\n`,
//     //     `computedInput: ${computedInput}\n`,
//     //     `targetLength: ${childList.length}\n`,
//     //     `at: ${at}\n`,
//     //     `position: ${n}\n`,
//     //     `safePosition: ${p}\n`,
//     //     `times: ${times}\n`,
//     //     `fragment:`, fragment
//     // )
//     this.setElement(fragment.firstElementChild!) // needs checks
//     if (childList.length === 0 || childList.length === p) {
//         target.appendChild(fragment)
//     } 
//     else {
//         target.insertBefore(fragment, childList[p])
//     }
// }


function insertV1(input, target, at, times) {
  var _this$cloneList;

  var posFromString = function posFromString(at, childList) {
    var posMap = {
      start: 0,
      middle: Math.floor(childList.length / 2),
      end: childList.length
    };
    return at in posMap ? posMap[at] : posMap.end;
  };

  var safePos = function safePos(n, length) {
    return n < 0 ? Math.max(length + (n + 1), 0) : Math.min(length, n);
  };

  var safeTimes = times ? Math.abs(Math.floor(times)) : 1;
  var clones = (0, _toConsumableArray2["default"])(Array(safeTimes - 1)).map(function () {
    return input.cloneNode(true);
  });
  var childList = target.children;
  var n = Check.isString(at) ? posFromString(at, childList) : Math.round(at);
  var p = safePos(n, childList.length);

  (_this$cloneList = this.cloneList).push.apply(_this$cloneList, (0, _toConsumableArray2["default"])(clones)); // needs refacto


  if (childList.length === 0 || childList.length === p) {
    target.appendChild(input);
    clones.forEach(function (clone) {
      return target.appendChild(clone);
    });
  } else {
    var childRef = childList[p];
    target.insertBefore(input, childRef);
    clones.forEach(function (clone) {
      return target.insertBefore(clone, childRef);
    });
  }
}

exports.insertV1 = insertV1;